import { GetUspsLocationsState } from './getUspsLocations.types'

const initialState: GetUspsLocationsState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
